module.exports = __webpack_public_path__ + "img/hw.7f9d4c18.png";